import { http } from '@/http'

async function getProfile() {
	const tz = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions()?.timeZone)
	return http.get(`/girl?tz=${tz || ''}`).then((response) => response.data.data)
}

export { getProfile }
